import PropTypes from 'prop-types';
import Tick from '../../../assets/icons/Tick.svg?react';
import styles from './InstitutionConfirmation.module.scss';

const InstitutionConfirmation = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
          &times;
        </button>

        <div className={styles.content}>
          <div className={styles.iconContainer}>
            <Tick width={80} height={80} />
          </div>

          <h1 className={styles.title}>Thank You</h1>

          <p className={styles.message}>Please contact your account admin</p>
        </div>
      </div>
    </div>
  );
};

InstitutionConfirmation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default InstitutionConfirmation;
